module.exports = __webpack_public_path__ + "static/media/em-state-events.24430013.jpeg";